module.exports = __webpack_public_path__ + "static/media/michaelWiener.86432afd.png";